import { Box, Button, InputAdornment, Modal, TextField } from '@mui/material'
import React from 'react'
// import AddIcon from '@mui/icons-material/Add'
// import RemoveIcon from '@mui/icons-material/Remove'
import AddSkillRateIcon from '../assets/imgs/add-skill-rate-image.svg'
import RemoveSkillRateIcon from '../assets/imgs/remove-skill-rate-image.svg'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  width: '300px',
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
  width: '460px',
}

const SetSkillRateModal = ({
  setSkillRateModal = false,
  handleSetSkillRateModal,
  component = '',
  setSkillRate,
  skillRate,
  selectedService,
  selectedSubService,
  rates,
  setRates,
  handleCreateServiceModal,
}) => {
  const handleSkillRateChange = (
    e,
    category,
    sub_category,
    ind,
    index,
    value,
    action,
  ) => {
    let arr = [...rates]
    let itemToUpdate = arr[index]?.sub_categories[ind]
    itemToUpdate[e.target.name] = Number(e.target.value)
    arr[index]?.sub_categories?.splice(ind, 1, itemToUpdate)
    setRates(arr)
  }

  const handleSkillRates = (e) => {
    e.preventDefault()
    localStorage.setItem('skill-rates', JSON.stringify(skillRate))
    handleSetSkillRateModal(false)
  }

  return (
    <div>
      <Modal
        open={setSkillRateModal}
        onClose={() => handleSetSkillRateModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="text-center">
            <form onSubmit={handleSkillRates}>
              <h3 className="fs-24 fw-bold">Set Rate</h3>
              <p className="font-weight-bold text-left my-3">
                <span className="text-capitalize">
                  {selectedService?.name + ' > '}
                </span>
                <span className="text-capitalize">
                  {selectedSubService?.name || skillRate?.subservice?.name}
                </span>
              </p>
              <div className="row gx-5">
                <div className="col-6">
                  <p className="color-primary text-center mb-1">
                    Base Cost ($)
                  </p>
                  <TextField
                    id="outlined-adornment-amount"
                    placeholder="40"
                    name="base_price"
                    type={'number'}
                    value={skillRate?.base_price || 0}
                    className="base_price p-0 text-center"
                    required
                    onChange={(e) =>
                      setSkillRate((prev) => ({
                        ...prev,
                        base_price: Number(e.target.value),
                      }))
                    }
                    inputProps={{
                      min: 0,
                      style: { textAlign: 'center', borderRadius: '12px' },
                    }}
                    InputProps={{
                      style: { padding: 0 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <img
                            src={AddSkillRateIcon}
                            alt={'Add Skill Rate Price '}
                            className="p-0 pointer"
                            height={79}
                            onClick={(e) =>
                              setSkillRate((prev) => ({
                                ...prev,
                                base_price: (+prev?.base_price || 0) + 5,
                              }))
                            }
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={RemoveSkillRateIcon}
                            alt={'Add Skill Rate Price '}
                            className="p-0 pointer"
                            height={79}
                            onClick={(e) =>
                              setSkillRate((prev) => ({
                                ...prev,
                                base_price: (+prev?.base_price || 0) - 5,
                              }))
                            }
                          />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </div>
                <div className="col-6">
                  <p className="color-primary text-center mb-1">Time (mins)</p>
                  <TextField
                    id="outlined-adornment-amount"
                    placeholder="40"
                    name="base_time"
                    type={'number'}
                    className="base_time p-0 text-center"
                    value={skillRate?.base_time || 0}
                    onChange={(e) =>
                      setSkillRate((prev) => ({
                        ...prev,
                        base_time: Number(e.target.value),
                      }))
                    }
                    sx={{ textAlign: 'center' }}
                    required
                    inputProps={{
                      min: 0,
                      style: { textAlign: 'center', borderRadius: '12px' },
                    }}
                    InputProps={{
                      style: { padding: 0, textAlign: 'center !important' },
                      startAdornment: (
                        <InputAdornment position="start">
                          <img
                            src={AddSkillRateIcon}
                            alt={'Add Skill Rate Price '}
                            className="p-0 pointer"
                            height={79}
                            onClick={(e) =>
                              setSkillRate((prev) => ({
                                ...prev,
                                base_time: (+prev?.base_time || 0) + 5,
                              }))
                            }
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={RemoveSkillRateIcon}
                            alt={'Add Skill Rate Price '}
                            className="p-0 pointer"
                            height={79}
                            onClick={(e) =>
                              setSkillRate((prev) => ({
                                ...prev,
                                base_time: (+prev?.base_time || 0) - 5,
                              }))
                            }
                          />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </div>
              </div>
              {rates?.map((item, index) => (
                <div
                  key={item?.id}
                  className="skill-rate-outlined-inputs-wrapper"
                >
                  <p className="font-weight-bold text-left my-3">
                    Set the rate of {item.name} Selection
                  </p>
                  {item?.sub_categories &&
                    item?.sub_categories?.map((nestedItem, ind) => (
                      <div className="row gx-5" key={nestedItem?.id}>
                        <div className="col-6">
                          <p className="color-primary text-center my-1 text-capitalize">
                            {nestedItem?.name} $
                          </p>
                          <TextField
                            id="outlined-adornment-amount"
                            placeholder="40"
                            value={rates[index]?.sub_categories[ind].price || 0}
                            inputProps={{
                              min: 0,
                              style: { textAlign: 'center' },
                            }}
                            type={'number'}
                            className="text-center p-0"
                            required
                            name="price"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <img
                                    src={AddSkillRateIcon}
                                    alt={'Add Skill Rate Price '}
                                    className="p-0 pointer"
                                    height={79}
                                    onClick={() => {
                                      let arr = [...rates]
                                      let itemToUpdate =
                                        arr[index]?.sub_categories[ind]
                                      itemToUpdate['price'] =
                                        Number(itemToUpdate['price']) + 5
                                      arr[index]?.sub_categories?.splice(
                                        ind,
                                        1,
                                        itemToUpdate,
                                      )
                                      setRates(arr)
                                    }}
                                  />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position="end">
                                  <img
                                    src={RemoveSkillRateIcon}
                                    alt={'Add Skill Rate Price '}
                                    className="p-0 pointer"
                                    height={79}
                                    onClick={() => {
                                      let arr = [...rates]
                                      let itemToUpdate =
                                        arr[index]?.sub_categories[ind]
                                      itemToUpdate['price'] =
                                        Number(itemToUpdate['price']) - 5
                                      arr[index]?.sub_categories?.splice(
                                        ind,
                                        1,
                                        itemToUpdate,
                                      )
                                      setRates(arr)
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            onChange={(e) =>
                              handleSkillRateChange(
                                e,
                                item,
                                nestedItem,
                                ind,
                                index,
                              )
                            }
                            variant="outlined"
                          />
                        </div>
                        <div className="col-6">
                          <p className="color-primary text-center my-1">
                            Time (mins)
                          </p>
                          <TextField
                            id="outlined-adornment-amount"
                            placeholder="40"
                            name="time"
                            inputProps={{
                              min: 0,
                              style: {
                                textAlign: 'center',
                                borderRadius: '12px',
                              },
                            }}
                            type={'number'}
                            className="text-center p-0"
                            value={rates[index]?.sub_categories[ind].time || 0}
                            onChange={(e) =>
                              handleSkillRateChange(
                                e,
                                item,
                                nestedItem,
                                ind,
                                index,
                              )
                            }
                            required
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <img
                                    src={AddSkillRateIcon}
                                    alt={'Add Skill Rate Price '}
                                    className="p-0 pointer"
                                    height={79}
                                    onClick={() => {
                                      let arr = [...rates]
                                      let itemToUpdate =
                                        arr[index]?.sub_categories[ind]
                                      itemToUpdate['time'] =
                                        Number(itemToUpdate['time']) + 5
                                      arr[index]?.sub_categories?.splice(
                                        ind,
                                        1,
                                        itemToUpdate,
                                      )
                                      setRates(arr)
                                    }}
                                  />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position="end">
                                  <img
                                    src={RemoveSkillRateIcon}
                                    alt={'Add Skill Rate Price '}
                                    className="p-0 pointer"
                                    height={79}
                                    onClick={() => {
                                      let arr = [...rates]
                                      let itemToUpdate =
                                        arr[index]?.sub_categories[ind]
                                      itemToUpdate['time'] =
                                        Number(itemToUpdate['time']) - 5
                                      arr[index]?.sub_categories?.splice(
                                        ind,
                                        1,
                                        itemToUpdate,
                                      )
                                      setRates(arr)
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                          />
                        </div>
                      </div>
                    ))}
                </div>
              ))}
              <Button
                id="btn-primary-no-shadow"
                disableElevation
                fullWidth
                type="submit"
                className="mt-5 pointer"
                onClick={() => handleSetSkillRateModal(false)}
              >
                Save
              </Button>
            </form>
          </div>
        </Box>
      </Modal>
      {/* <AddOrEditSkillsModal
        handleAddOrEditSkillsModal={handleAddOrEditSkillsModal}
        addOrEditSkillsModal={addOrEditSkillsModal}
      /> */}
    </div>
  )
}

export default SetSkillRateModal
